module.exports = __webpack_public_path__ + "img/ss-blog.e094b78c.jpg";